module.exports = __webpack_public_path__ + "img/p4.3d50a7b0.png";